import { useCallback } from 'react'

import { chatApi } from '@carrent/api'
import { useLiveData } from '@carrent/core'

/**
 * Список диалогов с непрочитанным.
 *
 * События здесь — знак «список изменился», как везде в системе:
 * порядок, счётчики и последнее сообщение считает сервер, и повторять
 * эту логику на клиенте значит однажды разойтись с ним.
 */
export const CHAT_LIST_EVENTS = [
  'chat.message',
  'chat.read',
  'chat.updated',
]

export function useConversations({ enabled = true } = {}) {
  const load = useCallback(async () => {
    const { data } = await chatApi.conversations()
    return data.data.items
  }, [])

  const { data, loading, error, refresh, isLive } = useLiveData({
    load,
    eventTypes: CHAT_LIST_EVENTS,
    enabled,
  })

  const items = data || []
  const totalUnread = items.reduce((n, c) => n + (c.unread_count || 0), 0)

  return { items, totalUnread, loading, error, refresh, isLive }
}
